import { PaintConfiguratorProps } from "@omni/types/components/props/paintConfigurator.props";
import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { BreakpointProvider } from "@/utils/breakpoints/breakpoints.provider";

import { StepBaseProps } from "./components/step/step.base";
import { PaintConfiguratorContextProvider } from "./context/paintConfigurator.context";
import { PaintConfiguratorWizardStepMeta } from "./paintConfigurator.types";

type BaseProps = RequireChildrenFor<PaintConfiguratorProps> & {
    steps: Array<{
        component: React.FC<StepBaseProps>;
        meta: PaintConfiguratorWizardStepMeta;
    }>;
};

const Base = ({
    children,
    collections,
    steps
}: RequireChildrenFor<BaseProps>) => {
    return (
        <BreakpointProvider>
            <PaintConfiguratorContextProvider
                collections={collections}
                steps={steps}
            >
                {children}
            </PaintConfiguratorContextProvider>
        </BreakpointProvider>
    );
};

export { Base };
